import { useMutation, useLazyQuery } from "@apollo/client/react"; import { useEffect, useState, useMemo } from "react";

import { Box, Divider, Grid, Typography } from "@mui/material";
import toast from 'react-hot-toast';
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { SelectInput } from "../../../../../components/selectInput/SelectInput";
import { useTabProfesionalAddProfessionalFields } from "../../hooks/TabProfesional/useTabProfesionalAddProfessionalFields";
import { useTabProfesionalAddProfessionalColumns } from "../../hooks/TabProfesional/useTabProfesionalAddProfessionalColumns";
import { useTabProfesionalAddProfessionalRows } from "../../hooks/TabProfesional/useTabProfesionalAddProfessionalRows";
import CREATE_EVALUACION_PROFESIONAL from "../../../../../data/graphQL/mutations/GestionAsistencial/createEvaluacionProfesional";
import GET_MEDICO_EVALUADOR from "../../../../../data/graphQL/queries/GestionAsistencial/getMedicoEvaluadorAsistencial";
import adaptEvaluacionProfesionalGrillaArray from "../../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalGrilla";
import { adaptFrecuenciaPlan, GET_FRECUENCIA_PLAN } from "../../../../../data/graphQL/queries/GestionAsistencial/getFrecuenciaPlan";
import { adaptFrecuenciasProfesionales } from "../../../../../adapters/gestionAsistencial/adaptFrecuenciasProfesionales";
import moment from "moment";
import adaptEvaluacionProfesionalReemplazoGrillaArray from "../../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalReemplazoGrilla";

const ID_TIPO_SEGUIMIENTO = 1;
const ID_TIPO_EVALUADOR = 2;

const ID_TIPO_PROFESIONAL_MEDICO = 1;
const ID_TIPO_PROFESIONAL_NUTRICIONISTA = 3;

const FORMA_LIQUIDACION_SERVICIO = 1;
const FORMA_LIQUIDACION_VISITA = 2;

const FIGURA_PROFESIONAL_SEGUIMIENTO = 1;
const FIGURA_URGENCIA = 7;

const FIGURA_PROFESIONAL_EVALUADOR_MEDICO = 3;

const reemplazoField = {
  name: "idEvaluacionProfesionalOriginal",
  displayName: "Profesional a reemplazar",
  type: "select",
}
const indexReemplazoField = 5

export function TabProfesionalAddProfessionalDialog({
  open,
  handleCloseDialog,
  evaluacionSelected,
  idDelegacion,
  refetchEvaluacionProfesional,
  refetchReemplazos,
  setEvaluacionProfesional,
  evaluacionProfesionales,
  setEvaluacionProfesionalReemplazo

}) {
  const { fechaHasta, fechaDesde, idPlanCuidado, idEvaluacion, origen } = evaluacionSelected;
  const fechaDesdeContrato = moment(fechaDesde).format("YYYY-MM-DD");
  const fechaHastaContrato = moment(fechaHasta).format("YYYY-MM-DD");
  const hoy = moment().startOf('day');
  const INITIAL_VALUES = {
    idTipoProfesional: 0,
    idFiguraProfesional: 0,
    fechaDesde: fechaDesdeContrato > hoy ? fechaDesdeContrato : hoy,
    fechaHasta: fechaHastaContrato,
    idFormaLiquidacion: 0,
    idProfesional: null,
    idClaseMonitoreo: 0,
    idTramo: null,
    viatico: 0,
    idTipo: 1,
    idFrecuenciaPlan: 0,
    idFrecuenciaRequerida: 0,
    idEvaluacionProfesionalOriginal: 0,
    idProfesionalOriginal: 0
  };
  const [selectionModel, setSelectionModel] = useState([]);
  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [valorTramoProfesional, setValorTramoProfesional] = useState(0);
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [frecuenciaPlan, setFrecuenciaPlan] = useState(0);
  const figurasReemplazo = [26, 27, 28, 29, 30, 31, 32, 33, 34, 35];
  const [showReemplazo, setShowReemplazo] = useState(false);
  const [profesionalesReemplazarOptions, setProfesionalesReemplazarOptions] = useState([]);

  const [getMedicoEvaluador, { data: dataMedicoEvaluador }] = useLazyQuery(GET_MEDICO_EVALUADOR);

  const [createEvaluacionProfesional, { loading: createLoading }] = useMutation(CREATE_EVALUACION_PROFESIONAL, {
    onCompleted: (data) => {
      if (data.createEvaluacionProfesional.success && data.createEvaluacionProfesional.valorEsperado) {
        toast.success(`Profesional creado con éxito.`);
        refetchEvaluacionProfesional().then(({ data }) => {
          setEvaluacionProfesional(adaptEvaluacionProfesionalGrillaArray(data));
        });
        refetchReemplazos().then(({ data }) => {
          setEvaluacionProfesionalReemplazo(adaptEvaluacionProfesionalReemplazoGrillaArray(data));
        });
        handleCloseDialog();
      } else {
        toast.error(data.createEvaluacionProfesional.error);
      }
    }
  });

  const handleSelectionChange = (newSelection) => {
    // Limita la selección a solo un registro.
    if (newSelection.length > 1) {
      setSelectionModel([newSelection[newSelection.length - 1]]);
    } else {
      setSelectionModel(newSelection);
    }
  };

  const setReemplazos = () => {
    setShowReemplazo(true);
    const profesionales = evaluacionProfesionales.filter((p) => p.idTipoProfesional == formValues?.idTipoProfesional && p.figuraProfesional == 'Seguimiento');
    let options = [];
    profesionales.map((prof) => options.push({
      id: prof.idEvaluacionProfesional, valor: prof.idEvaluacionProfesional, displayName: prof.profesional + " (" + moment(prof.fechaDesde).format("DD/MM/YYYY") + " - " + moment(prof.fechaHasta).format("DD/MM/YYYY") + ")"
    }));
    setProfesionalesReemplazarOptions(options);

    // si hay solo un profesional en la evaluación del tipo lo seteo como profesional a Reemplazar
    // y lo quito de las opciones de profesionales a seleccionar como reemplazante
    if (options.length == 1) {
      handleChange("idEvaluacionProfesionalOriginal", options[0].valor);
      handleChange("idProfesionalOriginal", profesionales[0]?.idProfesional);
    }
  };

  useEffect(() => {
    if (!dataMedicoEvaluador) return;
    if (dataMedicoEvaluador?.medicoEvaluador) {
      const medicoEvaluador = dataMedicoEvaluador?.medicoEvaluador;
      if (medicoEvaluador.mostrar) {
        setFormValues((prev) => ({
          ...prev,
          idProfesional: medicoEvaluador.profesional.idProfesional,
          idTipoProfesional: medicoEvaluador.profesional.idTipoProfesional,
          idClaseMonitoreo: medicoEvaluador.profesional.idClaseMonitoreo,
          idFiguraProfesional: medicoEvaluador.figuraProfesional.idFiguraProfesional,
          idFrecuenciaPlan: INITIAL_VALUES.idFrecuenciaPlan,
          idFrecuenciaRequerida: INITIAL_VALUES.idFrecuenciaRequerida,
          idEvaluacionProfesionalOriginal: INITIAL_VALUES.idEvaluacionProfesionalOriginal,
          idProfesionalOriginal: INITIAL_VALUES.idProfesionalOriginal,
          idFormaLiquidacion: medicoEvaluador.profesional.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO ? FORMA_LIQUIDACION_SERVICIO : FORMA_LIQUIDACION_VISITA
        }));
      } else {
        toast.error("El Médico evaluador es coordinador y no es posible asignarlo al contrato.");
      }
    } else {
      toast.error('No se encontró un médico evaluador para esta evaluación.');
      setFormValues((prev) => ({
        ...prev,
        idClaseMonitoreo: INITIAL_VALUES.idClaseMonitoreo,
        idProfesional: INITIAL_VALUES.idProfesional
      }));
    }
  }, [dataMedicoEvaluador]);

  const handleChange = async (name, value) => {
    if (name === 'idTipo') {
      setFormValues((prev) => ({
        ...prev,
        idTipoProfesional: INITIAL_VALUES.idTipoProfesional,
        idClaseMonitoreo: INITIAL_VALUES.idClaseMonitoreo,
        idProfesional: INITIAL_VALUES.idProfesional,
        idFiguraProfesional: INITIAL_VALUES.idFiguraProfesional,
        idFormaLiquidacion: INITIAL_VALUES.idFormaLiquidacion,
        idFrecuenciaPlan: INITIAL_VALUES.idFrecuenciaPlan,
        idFrecuenciaRequerida: INITIAL_VALUES.idFrecuenciaRequerida,
        idEvaluacionProfesionalOriginal: INITIAL_VALUES.idEvaluacionProfesionalOriginal,
        idProfesionalOriginal: INITIAL_VALUES.idProfesionalOriginal
      }));
      setShowReemplazo(false);

      if (value === ID_TIPO_EVALUADOR) {
        getMedicoEvaluador({
          variables: { idEvaluacion: idEvaluacion },
          fetchPolicy: 'no-cache'
        });
      }
    }

    if (name === 'idTipoProfesional') {
      setFormValues((prev) => ({
        ...prev,
        idClaseMonitoreo: INITIAL_VALUES.idClaseMonitoreo,
        idProfesional: INITIAL_VALUES.idProfesional,
        idFiguraProfesional: value === ID_TIPO_PROFESIONAL_NUTRICIONISTA ? 0 : INITIAL_VALUES.idFiguraProfesional,
        idFormaLiquidacion: value === ID_TIPO_PROFESIONAL_MEDICO ? FORMA_LIQUIDACION_SERVICIO : FORMA_LIQUIDACION_VISITA,
        idFrecuenciaPlan: INITIAL_VALUES.idFrecuenciaPlan,
        idFrecuenciaRequerida: INITIAL_VALUES.idFrecuenciaRequerida,
        idEvaluacionProfesionalOriginal: INITIAL_VALUES.idEvaluacionProfesionalOriginal,
        idProfesionalOriginal: INITIAL_VALUES.idProfesionalOriginal
      }));
      setShowReemplazo(false);
    }

    if (name === 'idFiguraProfesional') {
      handleFrecuenciaPlan(value);

      // si es reemplazo
      if (figurasReemplazo.filter((f) => f == value).length > 0)
        setReemplazos(); else {
        setShowReemplazo(false);
        handleChange("idEvaluacionProfesionalOriginal", 0);
      }
    }

    if (name === 'idProfesional') {
      const profesionalSelected = profesionalOptions.find((x) => x.id === value);


      setFormValues((prev) => ({
        ...prev,
        idClaseMonitoreo: value !== null ? profesionalSelected?.idClaseMonitoreo : INITIAL_VALUES.idClaseMonitoreo
      }));
      const profesionales = evaluacionProfesionales.filter((p) => p.idTipoProfesional == formValues?.idTipoProfesional);
      let options = [];
      profesionales.map((prof) => {
        if (prof.idProfesional !== value) {
          options.push({
            id: prof.idEvaluacionProfesional, valor: prof.idEvaluacionProfesional, displayName: prof.profesional + " (" + moment(prof.fechaDesde).format("DD/MM/YYYY") + " - " + moment(prof.fechaHasta).format("DD/MM/YYYY") + ")"
          });
        }
      });
      setProfesionalesReemplazarOptions(options);
    }

    if (name === "idEvaluacionProfesionalOriginal") {
      const evaluacionProfesionalSelected = evaluacionProfesionales.find((x) => x.idEvaluacionProfesional == value);
      setProfesionalesOptions(profesionalOptions.filter((p) => p.id !== evaluacionProfesionalSelected?.idProfesional));
    }

    setFormValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChangeTramoProfesional = (e) => {
    handleChange("idTramo", e.target.value);

    const newTramoProfesional = tramoProfesionalOptions.find(
      (tramo) => tramo.id === e.target.value
    );
    setValorTramoProfesional(newTramoProfesional.valor);
    handleChange("viatico", newTramoProfesional.valor);
  };

  const onClearValue = () => {
    handleChange("idTramo", INITIAL_VALUES.idTramo);
    setValorTramoProfesional(INITIAL_VALUES.viatico);
    handleChange("viatico", INITIAL_VALUES.viatico);
  };

  useEffect(() => {
    if (selectionModel.length > 0) {
      const selected = rows[selectionModel[0] - 1];
      setFormValues((prev) => ({
        ...prev,
        idHonorario: selected.idHonorarioProfesional,
        cambioSonda: selected.cambioSonda,
        capacitacion: selected.capacitacion,
        emergencia: selected.emergencia,
        extraduracion: selected.extraDuracion,
        valor: selected.valor,
        extra: selected.valorExtra,
        virtual: selected.valorVirtual
      }));
    }
  }, [selectionModel]);

  const handleSave = async () => {
    if (await validate()) {
      createEvaluacionProfesional({
        variables: {
          input: {
            idHonorario: formValues.idHonorario,
            cambioSonda: formValues.cambioSonda,
            capacitacion: formValues.capacitacion,
            emergencia: formValues.emergencia,
            extraduracion: formValues.extraduracion,
            valor: formValues.valor,
            extra: formValues.extra,
            virtual: formValues.virtual,
            idTipoProfesional: formValues.idTipoProfesional,
            idFiguraProfesional: formValues.idFiguraProfesional,
            fechaDesde: formValues.fechaDesde,
            fechaHasta: formValues.fechaHasta,
            idProfesional: formValues.idProfesional,
            idTramo: formValues.idTramo,
            idEvaluacion: idEvaluacion,
            viatico: formValues.viatico,
            ajustarFecha: false,
            idFrecuenciaPlan: formValues.idFrecuenciaPlan,
            idFrecuenciaRequerida: formValues.idFrecuenciaRequerida,
            idEvaluacionProfesionalOriginal: formValues.idEvaluacionProfesionalOriginal
          }
        }
      });
    }
  };

  // #region Validaciones 
  const validate = async () => {
    let errorMessage = '';
    if (!formValues.idHonorario) errorMessage += 'Honorario es requerido. \n';
    if (!formValues.idTipoProfesional) errorMessage += 'Tipo Profesional es requerido. \n';
    if (formValues.idFiguraProfesional === null) errorMessage += 'Figura Profesional es requerido. \n';
    if (!formValues.fechaDesde) errorMessage += 'Fecha Desde es requerida. \n';
    if (!formValues.fechaHasta) errorMessage += 'Fecha Hasta es requerida. \n';
    if (moment(formValues.fechaDesde, "YYYY-MM-DD").isBefore(moment(fechaDesde, "YYYY-MM-DD"), 'day') || moment(formValues.fechaDesde, "YYYY-MM-DD").isAfter(moment(fechaHastaContrato, "YYYY-MM-DD"), 'day'))
      errorMessage += 'Fecha Desde debe estar dentro del rango del contrato. \n';
    if (moment(formValues.fechaHasta, "YYYY-MM-DD").isBefore(moment(fechaDesde, "YYYY-MM-DD", 'day')) || moment(formValues.fechaHasta, "YYYY-MM-DD").isAfter(moment(fechaHastaContrato, "YYYY-MM-DD"), 'day'))
      errorMessage += 'Fecha Hasta debe estar dentro del rango del contrato. \n';
    // si el contrato ya inició la fecha desde no puede ser anterior a hoy
    if (moment(formValues.fechaDesde, "YYYY-MM-DD").isAfter(moment(fechaDesdeContrato, "YYYY-MM-DD"), 'day') && moment(formValues.fechaDesde, "YYYY-MM-DD").isBefore(hoy, 'day'))
      errorMessage += 'Fecha Desde no puede ser anterior al día de hoy. \n';

    if (!formValues.idProfesional) errorMessage += 'Profesional es requerido. \n';
    if (formValues.idTipo === ID_TIPO_SEGUIMIENTO &&
      formValues.idFiguraProfesional === 0) {
      errorMessage += 'Debe seleccionar una figura profesional. \n';
    }

    if (formValues.idFiguraProfesional === idFiguraUrgenciaOption &&
      moment(formValues.fechaDesde).format('YYYY-MM-DD') !== moment(formValues.fechaHasta).format('YYYY-MM-DD')) {
      errorMessage += 'Las urgencias solo pueden cargarse para un solo día. \n';
    }

    // Validación: Un mismo profesional no puede tener más de una asignación con figura Urgencia en el mismo día
    if (formValues.idFiguraProfesional === idFiguraUrgenciaOption) {
      const fechaDesdeFormato = moment(formValues.fechaDesde).format('YYYY-MM-DD');
      const duplicadoEmergencia = evaluacionProfesionales.some((profesional) =>
        profesional.idProfesional === formValues.idProfesional &&
        profesional.idFiguraProfesional === idFiguraUrgenciaOption &&
        moment(profesional.fechaDesde).format('YYYY-MM-DD') === fechaDesdeFormato
      );
      if (duplicadoEmergencia) {
        errorMessage += 'Un mismo profesional no puede tener más de una asignación con figura Urgencia en el mismo día. \n';
      }
    }

    // Validación de que no se pueda agregar un médico evaluador si ya existe uno.
    if (formValues.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO && formValues.idFiguraProfesional === FIGURA_PROFESIONAL_EVALUADOR_MEDICO) {
      const exists = evaluacionProfesionales.some((profesional) =>
        profesional.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO &&
        profesional.idFiguraProfesional === formValues.idFiguraProfesional
      );
      if (exists) {
        errorMessage += 'Ya existe un médico con esa figura profesional. \n';
      }
    }

    // Validación de rango de fechas para médicos de seguimiento no se pueden superponer
    if (formValues.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO && formValues.idFiguraProfesional === FIGURA_PROFESIONAL_SEGUIMIENTO) {
      const superposicion = evaluacionProfesionales.filter((profesional) =>
        profesional.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO &&
        profesional.idFiguraProfesional === FIGURA_PROFESIONAL_SEGUIMIENTO && (

          moment(formValues.fechaDesde).isSameOrAfter(moment(profesional.fechaDesde)) && moment(formValues.fechaDesde).isSameOrBefore(moment(profesional.fechaHasta)) ||
          moment(formValues.fechaHasta).isSameOrAfter(moment(profesional.fechaDesde)) && moment(formValues.fechaHasta).isSameOrBefore(moment(profesional.fechaHasta)))

      );

      if (superposicion.length > 0) {
        errorMessage += 'Ya existe un Médico de Seguimiento asignado para el rango de fechas ingresado.';
      }
    }

    // El rango de fechas para un Reemplazo se validará luego de seleccionar los profesionales

    if (errorMessage) {
      toast.error(errorMessage);
      return false;
    } else {
      return true;
    }
  };
  // #endregion 

  const { fields, tramoProfesionalOptions, profesionalOptions, dataFrecuenciaProfesional, figuraProfesionalOptions } =
    useTabProfesionalAddProfessionalFields({
      idPlanCuidado,
      idTipoProfesional: +formValues.idTipoProfesional,
      idDelegacion,
      idProfesionalOriginal: +formValues.idProfesionalOriginal,
      origenEvaluacion: origen,
      idEvaluacion: idEvaluacion
    });

  const idFiguraUrgenciaOption = useMemo(() => figuraProfesionalOptions?.find(option => option.displayName === "Urgencia")?.id, [figuraProfesionalOptions]);

  useEffect(() => {
    setProfesionalesOptions(profesionalOptions);
  }, []);

  useEffect(() => {
    if (formValues.idFiguraProfesional == idFiguraUrgenciaOption) {
      setFormValues((prev) => ({
        ...prev,
        idFrecuenciaPlan: INITIAL_VALUES.idFrecuenciaPlan,
        idFrecuenciaRequerida: INITIAL_VALUES.idFrecuenciaRequerida
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        idFrecuenciaPlan: frecuenciaPlan,
        idFrecuenciaRequerida: frecuenciaPlan
      }));
    }
  }, [formValues.idFiguraProfesional]);

  const { rows, totalCount, loading } = useTabProfesionalAddProfessionalRows({
    idDelegacion,
    idPlanCuidado,
    idTipoProfesional: formValues.idTipoProfesional,
    idFiguraProfesional: formValues.idFiguraProfesional,
    idClase: formValues.idClaseMonitoreo
  });

  useEffect(() => {
    setSelectionModel([]);
  }, [rows.length]);

  const [getFrecuenciaPlan, { data: dataFrecuenciaPlan, loading: frecuenciaPlanLoading }] = useLazyQuery(GET_FRECUENCIA_PLAN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFrecuenciaPlan) return;
    setFrecuenciaPlan(adaptFrecuenciaPlan(dataFrecuenciaPlan.frecuenciaPlan));
    handleChange("idFrecuenciaPlan", dataFrecuenciaPlan.frecuenciaPlan.idFrecuenciaProfesional);
    handleChange("idFrecuenciaRequerida", dataFrecuenciaPlan.frecuenciaPlan.idFrecuenciaProfesional);
  }, [dataFrecuenciaPlan]);

  const handleFrecuenciaPlan = (figura) => {
    if (!frecuenciaPlanLoading)
      getFrecuenciaPlan({
        variables: {
          idPlanCuidado: idPlanCuidado,
          idTipoProfesional: formValues.idTipoProfesional,
          idFiguraProfesional: figura
        }
      });
  };

  const updatedInputs = useMemo(() => {
    let inputs = structuredClone(fields).map((input) => {
      switch (input.name) {
        case 'idTipoProfesional':
          if (formValues?.idTipo === ID_TIPO_SEGUIMIENTO) {
            input.disabled = false;
          }
          break;
        case 'idProfesional':
          if (formValues?.idTipo === ID_TIPO_SEGUIMIENTO) {
            input.disabled = false;
            input.options = profesionalesOptions;
          }
          break;
        case 'idFiguraProfesional':
          if (formValues?.idTipo === ID_TIPO_SEGUIMIENTO) {
            input.disabled = false;
          }
          break;
        case 'idFrecuenciaRequerida':
          if (formValues.idFrecuenciaPlan > 0) {
            const frecuenciaPlan = parseFloat(dataFrecuenciaProfesional.frecuenciasProfesionales.filter((x) => x.idFrecuenciaProfesional == formValues.idFrecuenciaPlan)[0].frecuencia);
            const frecuenciasDisponibles = dataFrecuenciaProfesional.frecuenciasProfesionales.filter((x) => x.frecuencia <= frecuenciaPlan && x.frecuencia > 0);
            input.options = adaptFrecuenciasProfesionales({ frecuenciasProfesionales: frecuenciasDisponibles });
            input.disabled = false;
          }
          break;
        default:
          break;
      }

      return input;
    });

    if (showReemplazo) {
      inputs.splice(indexReemplazoField, 0, { ...reemplazoField, options: profesionalesReemplazarOptions });
    }

    return inputs;
  }, [
    fields,
    formValues,
    showReemplazo,
    profesionalesOptions,
    profesionalesReemplazarOptions
  ]
  );

  const columns = useTabProfesionalAddProfessionalColumns();

  const handleChangeReemplazo = (name, value) => {
    const profesional = evaluacionProfesionales.filter((p) => p.idEvaluacionProfesional == value);
    handleChange("idEvaluacionProfesionalOriginal", value);
    handleChange("idFrecuenciaRequerida", profesional[0].idFrecuenciaRequerida);
  };

  return (
    <CustomDialog
      title="Agregar profesional"
      maxWidth="md"
      fullWidth
      onCancel={handleCloseDialog}
      open={open}
      cancelText="Cerrar"
      onAccept={handleSave}
      acceptLoading={createLoading}>

      <Grid container spacing={3}>
        {updatedInputs.map((input, index) =>
          <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== "item" ? 12 : 0 }}>
            <RenderInputByTypeMobile
              key={`input-${input.name}-index-${index}`}
              input={input}
              handleChange={input.name === 'idEvaluacionProfesionalOriginal' ? handleChangeReemplazo : handleChange}
              value={formValues[input.name]}
            />
          </Grid>
        )}
      </Grid>
      <Divider sx={{ my: "20px" }} />
      <Typography sx={{ fontSize: "16px", fontWeight: "600", mb: "20px" }}>
        Honorarios profesionales
      </Typography>
      <DataGridGenerico
        columns={columns}
        rows={rows}
        totalCount={totalCount}
        loading={loading}
        checkboxSelection={true}
        toolbar={false}
        rowSelectionModel={selectionModel}
        onRowSelectionModelChange={handleSelectionChange} />

      <Box display="flex" alignItems="center" gap="10px" mt="20px">
        <SelectInput
          label="Tramo"
          name={"idTramo"}
          onChange={handleChangeTramoProfesional}
          fullWidth={false}
          sx={{ width: "300px" }}
          options={tramoProfesionalOptions}
          value={formValues.idTramo || ""}
          onClearValue={formValues.idTramo ? onClearValue : null}
          margin="none" />

        <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
          Valor: ${valorTramoProfesional || "-"}
        </Typography>
      </Box>
    </CustomDialog>);

}